import { IProjectCellRoute, IProjectCellRouteForm } from '_/types/projects/projectCellRoutes.types';
import zeusSdk from '_/utils/SDKs';

/**
 * Fetch all project cell routes for a project
 */
export const requestProjectCellRoutes = async (projectId: string): Promise<IProjectCellRoute[]> => {
  try {
    const options = {
      include: 'editor,extractioncell',
    };
    const { items } = await zeusSdk.projects.getChildren(projectId, 'projectcellroutes', options);
    return items as IProjectCellRoute[];
  } catch (error) {
    console.error('Error fetching project cell routes', error);
    return [];
  }
};

/**
 * Fetch a single project cell route
 */
export const requestProjectCellRoute = async (projectCellRouteId: string): Promise<IProjectCellRoute | null> => {
  try {
    return (await zeusSdk.projectCellRoutes.get(projectCellRouteId)) as IProjectCellRoute;
  } catch (error) {
    console.error('Error fetching selected project cell route', error);
    return null;
  }
};

/**
 * Create a project cell route
 */
export const createProjectCellRouteRequest = async (projectCellRoute: IProjectCellRouteForm): Promise<IProjectCellRoute> => {
  return (await zeusSdk.projectCellRoutes.create(projectCellRoute)) as IProjectCellRoute;
};

/**
 * Update a project cell route
 */
export const updateProjectCellRouteRequest = async (
  cellRouteId: string,
  changes: Partial<IProjectCellRouteForm>,
): Promise<IProjectCellRoute> => {
  return (await zeusSdk.projectCellRoutes.patch(cellRouteId, changes)) as IProjectCellRoute;
};

/**
 * Delete a project cell route
 */
export const deleteProjectCellRouteRequest = async (cellRouteId: string): Promise<void> => {
  await zeusSdk.projectCellRoutes.delete(cellRouteId);
};
